import React, { useState } from 'react';
import { Container, Navbar } from 'react-bootstrap';
import logo from '../../../Assets/Images/imgLogoBuyPolicyNow.png';
import { Drawer } from 'antd';
import { Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import posp from '../../../Assets/Images/MAn-02.png';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { GiHamburgerMenu } from "react-icons/gi";
// Import sidebar styles

function NavbarMobile() {
    const navigate = useNavigate()
    const [open, setOpen] = useState(false);
    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };
    function handleNavigate() {
        navigate(`${process.env.PUBLIC_URL}/posp`)
    }
    return (
        <>
            <Navbar className="bg-body-tertiary">
                <Container>
                    <div className="d-flex align-items-center justify-content-between">

                        <Navbar.Brand className="navbar-logo" href={`${process.env.PUBLIC_URL}/`}>
                            <img src={logo} className="logo-image" alt="logo" />
                        </Navbar.Brand>

                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    </div>
                    <Navbar.Toggle />
                    <Navbar.Collapse className="justify-content-end">
                        <Navbar.Text onClick={showDrawer}>
                            <div className='toggle-navbar-button'>
                            <GiHamburgerMenu fontSize={24} color='white'/>
                            </div>
                        </Navbar.Text>
                        <Drawer
                            zIndex={3001}
                            width={270}
                            placement="left"
                            title={
                                <div className='navbar-logo navbar-mobile-size'>
                                    <img src={logo} className="logo-image" alt="Logo" />

                                </div>
                            }
                            closable={false}
                            onClose={onClose}
                            open={open}
                        >
                            <Menu>
                                <MenuItem href={`${process.env.PUBLIC_URL}/`} className='navbar-menu-mobile'>Home</MenuItem>
                                <MenuItem href={`${process.env.PUBLIC_URL}/about`} className='navbar-menu-mobile'> About Us </MenuItem>

                                <SubMenu label="Health" className='navbar-menu-mobile'>
                                    <MenuItem href={`${process.env.PUBLIC_URL}/health-insurance`} className='navbar-menu-mobile'>Mediclaim</MenuItem>
                                    <MenuItem className='navbar-menu-mobile'>Parents</MenuItem>
                                    <MenuItem className='navbar-menu-mobile'>Covid-19</MenuItem>
                                </SubMenu>
                                <SubMenu label="Motor" className='navbar-menu-mobile'>
                                    <MenuItem href={`${process.env.PUBLIC_URL}/motor-insurance`} className='navbar-menu-mobile'>Car</MenuItem>
                                    <MenuItem href={`${process.env.PUBLIC_URL}/motor-insurance`} className='navbar-menu-mobile'>Bike</MenuItem>
                                    <MenuItem href={`${process.env.PUBLIC_URL}/cv-insurance`} className='navbar-menu-mobile'>Commercial Vehicle</MenuItem>
                                </SubMenu>
                                <SubMenu label="Life" className='navbar-menu-mobile'>
                                    <MenuItem href={`${process.env.PUBLIC_URL}/life-insurance`} className='navbar-menu-mobile'>Life</MenuItem>
                                    <MenuItem className='navbar-menu-mobile' >Investment</MenuItem>
                                </SubMenu>
                                <MenuItem href={`${process.env.PUBLIC_URL}/contact`} className='navbar-menu-mobile'>Contact</MenuItem>
                                <MenuItem>More</MenuItem>
                                <MenuItem >
                                    <div className='posp-navbar-img  d-flex align-items-center' >
                                        <img src={posp} alt="posp" className="posp-img" />
                                        <button className="posp-button-blink " onClick={handleNavigate}>
                                            Become a POSP
                                        </button>
                                    </div>
                                </MenuItem>
                            </Menu>
                        </Drawer>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>

    );
}

export default NavbarMobile;
